<template>
  <div class="marquees" v-if="!isMobile">
    <div class="marquee-container" @mouseover="pauseMarquee" @mouseout="resumeMarquee">
      <div class="marquee-wrapper">
        <div class="marquee" :style="{animationPlayState: playState}">
          <div class="marquee-item" v-for="(videoName, index) in videosRowOneTimestamped" :key="index">
            <video
              v-if="loadedVideos.includes(videoName)"
              :key="'video1-'+index"
              :src="'/figures/signatures/' + videoName"
              poster="/figures/video-placeholder.png"
              @mouseover="hoverVideo"
              @mouseleave="leaveVideo"
              playsinline
              muted
              autoplay
              loop
              @canplay="loadNextVideo"
            >
            </video>
          </div>
        </div>
        <div class="marquee" :style="{animationPlayState: playState}">
          <div class="marquee-item" v-for="(videoName, index2) in videosRowOneTimestamped" :key="index2">
            <video
              v-if="loadedVideos.includes(videoName)"
              :key="'video2-'+index2"
              :src="'/figures/signatures/' + videoName"
              poster="/figures/video-placeholder.png"
              @mouseover="hoverVideo"
              @mouseleave="leaveVideo"
              playsinline
              muted
              autoplay
              loop
              @canplay="loadNextVideo"
            >
            </video>
          </div>
        </div>
      </div>
    </div>

    <!-- Second Marquee -->
    <div class="marquee-container" @mouseover="pauseMarquee2" @mouseout="resumeMarquee2">
      <div class="marquee-wrapper">
        <div class="marquee marquee-left" :style="{animationPlayState: playState2}">
          <div class="marquee-item" v-for="(videoName, index) in videosRowTwoTimestamped" :key="index">
            <video
              v-if="loadedVideos.includes(videoName)"
              :key="'video3-'+index"
              :src="'/figures/signatures/' + videoName"
              poster="/figures/video-placeholder.png"
              @mouseover="hoverVideo"
              @mouseleave="leaveVideo"
              playsinline
              muted
              autoplay
              loop
              @canplay="loadNextVideo"
            >
            </video>
          </div>
        </div>
        <div class="marquee marquee-left" :style="{animationPlayState: playState2}">
          <div class="marquee-item" v-for="(videoName, index2) in videosRowTwoTimestamped" :key="index2">
            <video
              v-if="loadedVideos.includes(videoName)"
              :key="'video4-'+index2"
              :src="'/figures/signatures/' + videoName"
              poster="/figures/video-placeholder.png"
              @mouseover="hoverVideo"
              @mouseleave="leaveVideo"
              playsinline
              muted
              autoplay
              loop
              @canplay="loadNextVideo"
            >
            </video>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <div class="spacer-1"></div>
    <div class="player-container">
      <div class="left-action" @click="moveLeft">
        <img src="/figures/arrow-left.png" />
      </div>
      <div class="video-player">
        <video
          preload
          playsinline
          autoplay
          poster="/figures/video-placeholder.png"
          :muted="isMuted"
          ref="videoPlayer"
          :key="mobileActiveSrc"
          @ended="ended"
          @click="toggleSound"
          :src="mobileActiveSrc"
        >
          <source :src="mobileActiveSrc" />
        </video>
      </div>
      <div class="right-action" @click="moveRight">
        <img src="/figures/arrow-right.png" />
      </div>
    </div>
    <div class="spacer-1"></div>
    <div class="sound-row sound-row--mobile">
      <SoundIcon :muted="isMuted" />
      <div class="sound-toggle" @click="toggleSound">{{ isMuted ? 'Sound Off' : 'Sound On' }}</div>
    </div>
  </div>
</template>

<script>
import SoundIcon from './SoundIcon.vue';

export default {
  components: {
    SoundIcon
  },
  data() {
    return {
      playState: 'running',
      playState2: 'running',
      videosRowOne: ['carson.mp4', 'eternal.mp4', 'evenings.mp4', 'laurel.mp4', 'khari.mp4', 'jeramey.MP4', 'entropy.mp4', 'luke.mp4', 'anna.mp4', 'lychee.MOV', 'jacob.mp4', 'anjan-zanny.mp4', 'cab.mp4', 'lisa.mp4' ],
      videosRowTwo: ['maxime.mp4', 'sonia.mp4', 'diva.mp4', 'bdm.mp4', 'raprave.mov', 'sean.mp4', 'soldout.mov', 'sophia.mp4', 'tlon.mp4', 'trevor.mp4', 'prpl.mp4', 'marisa.mp4', 'mo.mp4', 'dagsen.mp4' ],
      activeVideo: null,
      audioContext: new AudioContext(),
      gainNode: null,
      mediaQueue: [],
      currentMedia: 0,
      isMuted: true,
      loadedVideos: [],
    };
  },
  computed: {
    videosRowOneTimestamped() {
      return this.videosRowOne.map(name => name + '#t=0.001') 
    },
    videosRowTwoTimestamped() {
      return this.videosRowTwo.map(name => name + '#t=0.001')
    },
    isMobile(){
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    },
    mobileActiveSrc() {
      return '/figures/signatures/' + this.mediaQueue[this.currentMedia];
    },
  },
  mounted() {
    this.mediaQueue = this.mediaQueue.concat(this.videosRowOneTimestamped);
    this.mediaQueue = this.mediaQueue.concat(this.videosRowTwoTimestamped);

    // shuffle em up buttercup 
    for (let i = this.mediaQueue.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [this.mediaQueue[i], this.mediaQueue[j]] = [this.mediaQueue[j], this.mediaQueue[i]];
    }

    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.loadNextVideo();
        observer.disconnect();
      }
    }, {
      root: null, // relative to the viewport
      rootMargin: '200% 0px', // Start loading when the user is a screen height away
      threshold: 0.1 // 10% of the component is visible
    });

    observer.observe(this.$el);
  },
  methods: {
    loadNextVideo() {
      if (this.loadedVideos.length < this.mediaQueue.length) {
        this.loadedVideos.push(this.mediaQueue[this.loadedVideos.length]);
      }
    },
    pauseMarquee() {
      // this.playState = 'paused';
    },
    pauseMarquee2() {
      // this.playState = 'paused';
    },
    resumeMarquee() {
      this.playState = 'running';
    },
    resumeMarquee2() {
      this.playState2 = 'running';
    },
    async hoverVideo(event) {
      this.activeVideo = event.target;
      this.activeVideo.muted = false;
      this.activeVideo.play();
    },
    leaveVideo() {
      this.activeVideo.muted = true;
    },
    ended(){
      this.currentMedia++;
      if(this.currentMedia >= this.mediaQueue.length){
        this.currentMedia = 0;
      }
    },
    moveLeft(){
      this.currentMedia--;
      if(this.currentMedia < 0){
        this.currentMedia = this.mediaQueue.length - 1;
      }
    },
    moveRight(){
      this.currentMedia++;
      if(this.currentMedia >= this.mediaQueue.length){
        this.currentMedia = 0;
      }
    },
    toggleSound(){
      this.isMuted = !this.isMuted;
    },
  },
};
</script>

<style scoped>
.marquee-container {
  display: flex;
  overflow: hidden;
  padding-top: 2rem;
  padding-bottom: 2rem;
  /* white-space: nowrap; */
}

.marquee-wrapper {
  display: flex;
  white-space: nowrap;
  width: 200%; /* 2 times 100% to fit both marquee divs */
}

.marquee {
  display: flex;
  justify-content: space-between;
  width: 100%;
  animation: marquee 70s linear infinite;
}
.marquee-left {
  animation: marquee 70s linear infinite reverse;
}

.marquee-item {
  margin: 0;
  margin-right: 4rem;
  /* background: gray; */
  width: 30vw;
  display: flex;
  border-radius: 1rem;
  overflow: hidden;
  transform-origin: center center;
  transition: all 75ms ease-in-out;
  transform: translate3d(0,0,0);
}

.marquee-item:hover {
  transform: translate3d(0,0,0) scale(1.05);
}

.marquee-item video {
  height: auto;
  width: 100%;
}

@keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-100%);
  }
}


@media screen and (max-width: 700px) {  
  /* Your CSS here */

  .marquee-item-edges {
    display: none;
  }

  .marquee-item {
    width: 63vw;
    margin-right: 1rem;
    height: 10rem;
  }

  /* .marquee-container {
    width: 400%;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .marquee {
    width: 50%;
  }

  @keyframes marquee {
  0% {
    transform: translateX(0%);
  }
  100% {
    transform: translateX(-200%);
  }
  } */
}

.player-container {
  display: grid;
  grid-template-columns: 4rem 1fr 4rem;
  min-height: 16rem;
}

.video-player {
  width: 100%;
  border-radius: 10px;
}

.video-player video {
  width: 100%;
}

.left-action,
.right-action {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
}

.left-action img,
.right-action img {
  width: 24px;
  height: auto;
}

.sound-toggle {
  font-family: 'ISO';
  font-size: 1.4rem;
  line-height: 140%;
  text-align: center;
  color: #979797;
}

</style>
